import { ISwiftCardInfoDetails } from '../types';

export const EMPTY_SWIFT_CARD_INFO: ISwiftCardInfoDetails = {
  cardNumber: '',
  activationDate: undefined,
  swiftCardState: undefined,
  newCardDeliveryAddress: {
    address1: '',
    address2: '',
    town: '',
    county: '',
    country: '',
    postCode: '',
  },
};
